import React from 'react'
import { Link } from 'react-router-dom'
import './notFound.css'

function NotFound() {
    return (
        <div className="contain">
            <div className="error404page">
                <div className="newcharacter404">
                    <div className="chair404"></div>
                    <div className="leftshoe404"></div>
                    <div className="rightshoe404"></div>
                    <div className="legs404"></div>
                    <div className="torso404">
                        <div className="body404"></div>
                        <div className="leftarm404"></div>
                        <div className="rightarm404"></div>
                        <div className="head404">
                            <div className="eyes404"></div>
                        </div>
                    </div>
                    <div className="laptop404">
                        <h3>
                            OOPs this is not the page you are looking for
                        </h3>
                        <Link className='button' to={'/show-users'}>Let's go Home</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound
